












































import { Component, Prop, Vue } from "vue-property-decorator";
import { shareDataService } from "@/service/sharedataservice";

@Component({
  components: {},
})
export default class GlobalDialog extends Vue {
  public shareDataService = shareDataService;
}
